export default __webpack_public_path__ + "static/3-mobile-2a091458620d202f6cfc464f561145e1.svg";